import { Field, InjectedFormProps } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import { FormAddListItemProps } from 'dashboard/forms/FormAddListItem/FormAddListItem';
import {
  isMaxNumber,
  isNumeric,
  isPositiveNumber,
  isRequired,
  isValidLatitude,
  isValidLongitude,
  withMessage,
} from 'lib/utils/formValidation';

const validate = {
  latitude: [
    withMessage('Please enter a latitude', isRequired),
    withMessage('Please enter a latitude between -90 and 90', isValidLatitude),
  ],
  longitude: [
    withMessage('Please enter a longitude', isRequired),
    withMessage('Please enter a longitude between -180 and 180', isValidLongitude),
  ],
  radius: [
    withMessage('Please enter a radius in meters', isRequired),
    withMessage('Please enter a numeric radius value', isNumeric),
    withMessage('Please enter a positive radius value', isPositiveNumber),
    // NOTE: 20 000 000 meters is a bit less than half the circumference of the Earth which makes sense as a radius max
    withMessage('Please enter a smaller radius value', isMaxNumber(20000000)),
  ],
};

const GeolocationFields = ({ submitting }: InjectedFormProps<{}, FormAddListItemProps>) => {
  return (
    <>
      <Field
        component={InputField}
        label='Latitude'
        name='latitude'
        id='latitude'
        disabled={submitting}
        placeholder='Latitude (-90 to 90) (e.g. 37.788410)'
        validate={validate.latitude}
      />
      <Field
        component={InputField}
        label='Longitude'
        name='longitude'
        id='longitude'
        disabled={submitting}
        placeholder='Longitude (-180 to 180) (e.g. -122.405410)'
        validate={validate.longitude}
      />
      <Field
        component={InputField}
        label='Radius'
        name='radiusMeters'
        id='radiusMeters'
        disabled={submitting}
        placeholder='Meters'
        validate={validate.radius}
      />
    </>
  );
};

export default GeolocationFields;
